(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stavrodia-trust-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stavrodia-trust-bar')) {
    customElements.define('stavrodia-trust-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.track = this.querySelector('[data-trust-track]');
        this.viewport = this.querySelector('[data-trust-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-trust-item]'));
        this.closeButton = this.querySelector('[data-trust-close]');
        this.mobileQuery = window.matchMedia('(max-width: 999px)');
        this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.startX = null;
        this.speed = Number(this.dataset.speed) || 4000;

        if (this.isRememberedClosed()) {
          this.hidden = true;
          return;
        }

        this.onClose = () => this.close();
        this.onPointerDown = (event) => this.pointerDown(event);
        this.onPointerUp = (event) => this.pointerUp(event);
        this.onMediaChange = () => this.mediaChanged();
        this.onVisibilityChange = () => document.hidden ? this.stop() : this.start();
        this.onFocusIn = () => this.stop();
        this.onFocusOut = () => this.start();

        this.closeButton.addEventListener('click', this.onClose);
        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.viewport.addEventListener('pointerup', this.onPointerUp);
        this.viewport.addEventListener('pointercancel', this.onPointerUp);
        this.mobileQuery.addEventListener('change', this.onMediaChange);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);

        this.show(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (!this.initialized || !this.closeButton) return;

        this.closeButton.removeEventListener('click', this.onClose);
        this.viewport.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport.removeEventListener('pointerup', this.onPointerUp);
        this.viewport.removeEventListener('pointercancel', this.onPointerUp);
        this.mobileQuery.removeEventListener('change', this.onMediaChange);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.initialized = false;
      }

      isRememberedClosed() {
        if (this.dataset.rememberClose !== 'true') return false;
        if (window.Shopify && window.Shopify.designMode) return false;

        try {
          return sessionStorage.getItem(this.dataset.storageKey) === 'closed';
        } catch (error) {
          return false;
        }
      }

      close() {
        this.stop();
        this.hidden = true;

        if (this.dataset.rememberClose === 'true') {
          try {
            sessionStorage.setItem(this.dataset.storageKey, 'closed');
          } catch (error) {
            return;
          }
        }
      }

      pointerDown(event) {
        if (!this.mobileQuery.matches) return;
        this.startX = event.clientX;
        this.stop();
      }

      pointerUp(event) {
        if (this.startX === null || !this.mobileQuery.matches) return;

        const distance = event.clientX - this.startX;
        this.startX = null;

        if (Math.abs(distance) > 35) {
          this.show(distance < 0 ? this.index + 1 : this.index - 1);
        }

        this.start();
      }

      mediaChanged() {
        this.stop();
        this.show(this.mobileQuery.matches ? this.index : 0);
        this.start();
      }

      show(index) {
        if (this.slides.length === 0) return;

        this.index = (index + this.slides.length) % this.slides.length;
        this.track.style.transform = this.mobileQuery.matches ? `translateX(-${this.index * 100}%)` : 'none';

        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', this.mobileQuery.matches && slideIndex !== this.index ? 'true' : 'false');
        });
      }

      start() {
        if (!this.mobileQuery.matches || this.slides.length < 2 || this.reducedMotionQuery.matches || document.hidden || this.hidden) return;

        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), this.speed);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stavrodia-value-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stavrodia-value-strip')) {
    class StavrodiaValueStrip extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-value-strip-item]'));
        this.previousButton = this.querySelector('.stavrodia-value-strip__arrow--previous');
        this.nextButton = this.querySelector('.stavrodia-value-strip__arrow--next');
        this.viewport = this.querySelector('.stavrodia-value-strip__viewport');
        this.mobileMedia = window.matchMedia('(max-width: 699px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.currentIndex = 0;
        this.startX = null;
        this.timer = null;

        this.onPrevious = () => this.goTo(this.currentIndex - 1, true);
        this.onNext = () => this.goTo(this.currentIndex + 1, true);
        this.onModeChange = () => this.applyMode();
        this.onVisibilityChange = () => {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        };
        this.onPointerDown = (event) => {
          this.startX = event.clientX;
        };
        this.onPointerUp = (event) => {
          if (this.startX === null) return;
          const distance = event.clientX - this.startX;
          this.startX = null;
          if (Math.abs(distance) < 40) return;
          if (distance > 0) this.onPrevious();
          if (distance < 0) this.onNext();
        };

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.viewport?.addEventListener('pointerdown', this.onPointerDown);
        this.viewport?.addEventListener('pointerup', this.onPointerUp);
        this.viewport?.addEventListener('pointercancel', () => { this.startX = null; });
        this.mobileMedia.addEventListener('change', this.onModeChange);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());
        this.applyMode();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.viewport?.removeEventListener('pointerdown', this.onPointerDown);
        this.viewport?.removeEventListener('pointerup', this.onPointerUp);
        this.mobileMedia?.removeEventListener('change', this.onModeChange);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
      }

      applyMode() {
        this.stopAutoplay();
        if (!this.mobileMedia.matches) {
          this.items.forEach((item) => {
            item.classList.add('is-active');
            item.setAttribute('aria-hidden', 'false');
          });
          return;
        }
        this.goTo(this.currentIndex, false);
        this.startAutoplay();
      }

      goTo(index, restartAutoplay) {
        if (!this.items.length || !this.mobileMedia.matches) return;
        this.currentIndex = (index + this.items.length) % this.items.length;
        this.items.forEach((item, itemIndex) => {
          const active = itemIndex === this.currentIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        if (restartAutoplay) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      startAutoplay() {
        if (!this.mobileMedia.matches || this.reducedMotion.matches || document.hidden) return;
        if (this.dataset.autoplay !== 'true' || this.items.length < 2 || this.timer) return;
        const delay = Number(this.dataset.cycleSpeed) || 4000;
        this.timer = window.setInterval(() => this.goTo(this.currentIndex + 1, false), delay);
      }

      stopAutoplay() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    customElements.define('stavrodia-value-strip', StavrodiaValueStrip);
  }

  } catch(e) { console.error(e); }
})();
})();
